// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3ehKv","savePackageButton":"ClientWallet_savePackageButton__3gd_c"};